'use client';

import { CircularProgress } from '@mui/material';
import { AnimatePresence, motion } from 'motion/react';
import { useLayoutEffect, useRef, useState } from 'react';
import { LuPlus } from 'react-icons/lu';
/**
 * Animated action-button content for grid cells — swaps icon + label with a
 * popLayout crossfade and tweens the wrapper width in px (measured via ref) so
 * the label-length change doesn't snap or distort text.
 */
export const AnimatedActionContent = ({
  active,
  labels,
  icon,
  activeIcon
}) => {
  const innerRef = useRef(null);
  const [width, setWidth] = useState('auto');
  useLayoutEffect(() => {
    const el = innerRef.current;
    if (el) setWidth(el.offsetWidth);
  }, [active, labels.idle, labels.active]);
  return <motion.span initial={false} animate={{
    width
  }} transition={{
    duration: 0.18,
    ease: 'easeOut'
  }} className="inline-flex overflow-hidden whitespace-nowrap">
            <span ref={innerRef} className="inline-flex items-center gap-1">
                <AnimatePresence mode="popLayout" initial={false}>
                    <motion.span key={active ? 'active' : 'idle'} initial={{
          opacity: 0,
          y: 4
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -4
        }} transition={{
          duration: 0.15,
          ease: 'easeOut'
        }} className="inline-flex items-center gap-1">
                        {active ? activeIcon ?? <CircularProgress size={14} className="mr-0.25!" /> : icon ?? <LuPlus className="size-3.5! text-muted-foreground! -ml-0.5! -mr-0.25!" />}
                        <span className="text-xs! text-muted-foreground!">{active ? labels.active : labels.idle}</span>
                    </motion.span>
                </AnimatePresence>
            </span>
        </motion.span>;
};